import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { queryKeys } from "../../shared/query-keys";

import { Messages, QueryParamsOf } from "../../core/api";
import { createQueryGroup } from "../../core/api/queries";

export default createQueryGroup(({ api }) => ({
  metrics: (
    query: QueryParamsOf<"get", "./patient_task_instances/:patientTaskInstanceId/metrics">,
    patientTaskInstanceId: Messages["PatientTaskInstanceId"]
  ) => {
    return queryOptions({
      queryKey: queryKeys.patientTaskMetrics.search(query),
      queryFn: () =>
        api.get("./patient_task_instances/:patientTaskInstanceId/metrics", {
          query,
          path: { patientTaskInstanceId },
        }),
      placeholderData: keepPreviousData,
    });
  },
  getCount: (patientTaskInstanceId: Messages["PatientTaskInstanceId"]) => {
    return queryOptions({
      queryKey: queryKeys.patientTaskMetrics.getCount(patientTaskInstanceId),
      queryFn: () =>
        api.get("./patient_task_instances/:patientTaskInstanceId/metrics/count", {
          path: { patientTaskInstanceId },
        }),
    });
  },
}));
